module.exports = __webpack_public_path__ + "static/design-team-logo-black-ec7df2ef9d4a5782831695d2f9844915.png";